import { render, staticRenderFns } from "./settings-lists-taskstages.vue?vue&type=template&id=e71ca59a&"
import script from "./settings-lists-taskstages.ts?vue&type=script&lang=ts&"
export * from "./settings-lists-taskstages.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports